// THE TWO HOLE READINGS, AND THE COLOURS THAT KEEP THEM APART.
//
// The manual's holes and the mesh's own are drawn on ONE part at the same time, out of two
// tables, into one list of marks — so with both walking one ladder from the top, row 1 of
// either was red and a red ring on the part belonged to whichever table you happened to be
// looking at. Colour was answering "which row" twice and "which reading" never.
//
// So the reading is the family and the hue is the detail inside it. Warm is what the drawing
// says should be bored; one cool blue is what the mesh has got. Neither family can be
// mistaken for the other at a glance, and neither takes orange (the selection rim) or
// emerald (the verdict line), which mean something else again.

// WHAT THE MESH HAS, IN ONE COLOUR. Every measured bore, every measured mark: this blue.
// Eight hues down that table said "which row of the reading" — a question nobody asks of a
// list whose rows have no relation to one another. What is asked is which ring on the part
// is the row under the cursor, and a set of rows lit together answers that by BEING the set.
export const MESH_HOLE_COLOUR = 0x0ea5e9;

// WHAT THE DRAWING SAYS, ONE HUE PER PIECE OF HARDWARE. Here the colour has real work: a
// screw is red wherever it appears, the dowels are yellow, the barrel nuts purple — so the
// pattern of an assembly is visible on the part without reading a column.
//
// Ordered for separation at the top, because most parts take two or three fasteners and
// those are the hues that must not be argued over. Five, and it wraps: a part taking six
// distinct pieces of hardware is not a part this ladder can help with anyway.
export const SAID_COLOURS = [
  0xef4444, 0xeab308, 0xa855f7, 0xec4899, 0xd946ef,
];

// A colour as CSS, from the same number the viewer paints with — one source, so a row and the
// thing it points at cannot end up different shades of the same idea.
export const tint = (hex: number): string => `#${hex.toString(16).padStart(6, '0')}`;

// ONE HUE PER PIECE OF HARDWARE, in the order the holes are listed — the holes table's rows and
// the joint view's bores, so a screw is the same red in both.
export function huesByVia(holes: { id: string; via: string | null }[]): Map<string, number> {
  const seen = new Map<string, number>();
  const out = new Map<string, number>();
  for (const h of holes) {
    const key = h.via ?? h.id;
    let hue = seen.get(key);
    if (hue == null) {
      hue = SAID_COLOURS[seen.size % SAID_COLOURS.length];
      seen.set(key, hue);
    }
    out.set(h.id, hue);
  }
  return out;
}
